import React from "react";
import {
  HeaderBtn,
  Logo,
  Navigation,
  OffCanvas,
  MobileWidgets,
} from "../../components";
import { navMenu } from "../../data";

const Header = () => {
  return (
    <header
      style={{
        backgroundColor: `#b7124d`,
      }}
      className={`dg__header header--absolute space-right-left`}
    >
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-lg-2 col-xl-2 col-6">
            {/* logo */}
            <Logo image={"/images/logo/1.png"} />
          </div>
          <div className="col-lg-7 col-xl-8 d-none d-lg-block">
            {/* navigation */}
            <Navigation />
          </div>
          <div className="col-lg-3 col-xl-2 col-6">
            {/* header buttons */}
            <HeaderBtn />
          </div>
        </div>
      </div>

      <OffCanvas id={"offcanvas-mobile-menu"} data={navMenu}>
        <MobileWidgets />
      </OffCanvas>
    </header>
  );
};

export default Header;
